import {
	Button,
	Checkbox,
	DatePicker,
	Form,
	Switch,
	UploadFile,
	message,
} from 'antd'
import { AdminCModal } from 'app/components/Common'
import React, { useState } from 'react'
import { View } from 'styles/reactnative'
import {
	PopUpInputSection,
	PopUpTitleSection,
	PopUpWrapper,
} from '../../styles'
import SettingTitle from '../../SettingTitle'
import SettingInput from '../../SettingInput'
import PopUpModalHeader from './PopUpModalHeader'

import SettingMultiInput from './SettingMultiInput'
import PopUpImage from './PopUpImage'
import { awsUploadImage } from 'utils/awsImageStorage'
import { usePopUp } from 'app/hooks/AdminSettings/popUp'
import { anyTruthy } from 'utils/ExpensiveFunction'
import SettingTextarea from '../../SettingTextarea'
import moment from 'moment'
import dayjs from 'dayjs';
import SettingGroup from '../../SettingGroup'


const PopUpUpdateModal = ({ data, showModal, setShowModal }) => {
	const [messageApi, contextHolder] = message.useMessage()

	const { updatePopUp } = usePopUp()

	const [title, setTitle] = useState(data?.title)
	const [group, setGroup] = useState(data?.target)
	const [content, setContent] = useState(data?.content)
	const [images, setImages] = useState(JSON.parse(data?.images || '[]'))
	const [apiImages, setApiImages] = useState(JSON.parse(data?.images || '[]'))

	const [sizeWidth, setSizeWidth] = useState(data?.width)
	const [sizeHeight, setSizeHeight] = useState(data?.height)
	const [xAxis, setXAxis] = useState(data?.x)
	const [yAxis, setYAxis] = useState(data?.y)
	const [activate, setActivate] = useState(data?.active)
	const [mobileUse, setMobileUse] = useState(data?.mobile)
	const [startDate, setStartDate] = useState(dayjs(data?.startdate?.split('T')[0]).add(1, 'day').format('YYYY-MM-DD'))

	const [endDate, setEndDate] = useState(dayjs(data?.enddate?.split('T')[0]).add(1, 'day').format('YYYY-MM-DD'))

	const onFinish = async (values: any) => {
		if (anyTruthy(title, content)) {
			let resultImages: any = []
			
			let cleanContent = content;
			if (content === '<p class="editor-paragraph"><br></p>' || content === '<p><br></p>') {
				cleanContent = '';
			}
			
			await updatePopUp({
				id: data?.id,
				title,
				content: cleanContent,
				images: images || [],
				mobile: mobileUse,
				x: xAxis,
				y: yAxis,
				width: sizeWidth,
				height: sizeHeight,
				startdate: startDate,
				enddate: endDate,
				active: activate,
				group_id: group,
			})
			setShowModal(!showModal)
		} else {
			messageApi.info('제목이나 내용을 추가해야 합니다.')
		}
	}

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo)
	}
	return (
		<AdminCModal width={800} show={showModal} setShow={setShowModal}>
			{contextHolder}
			<Form
				layout="vertical"
				style={{
					maxWidth: '100%',
					width: '100%',
					padding: 10,
					alignSelf: 'center',
					margin: 'auto',
				}}
				initialValues={{ remember: true }}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				autoComplete="off"
				size="middle">
				<PopUpModalHeader title={'구분'} content={'내용'} />
				<View
					style={{
						flexDirection: 'row',
						height: '100%',
						width: '100%',
					}}>
					<PopUpTitleSection style={{ borderRight: 0 }}>
						<SettingTitle title="타이틀" />
						<SettingTitle title="그룹" />
						<SettingTitle title="내용" style={{ height: 400 }}  />
						<SettingTitle title="이미지" style={{ height: 130 }} />
						<SettingTitle title="사이즈" />
						<SettingTitle title="x위치" />
						<SettingTitle title="활성화" />
						<SettingTitle title="모바일사용" />
						<SettingTitle title="시작일" style={{ border: 0 }} />
						<SettingTitle title="종료일" style={{ border: 0 }} />
					</PopUpTitleSection>
					<PopUpInputSection>
						<SettingInput
							title={'타이틀'}
							value={title}
							setValue={setTitle}
						/>
						<SettingGroup
							title={'그룹설정'}
							group={group}
							setGroup={setGroup}
						/>
						<SettingTextarea
							title={'내용'}
							value={content}
							setValue={setContent}
							style={{ height: 400, width: '100%' }}
							update={true}
						/>
						<PopUpImage
							apiImages={apiImages}
							setApiImages={setApiImages}
							images={images}
							setImages={setImages}
						/>
						<SettingMultiInput
							title={'가로'}
							content={'세로'}
							fValue={sizeWidth}
							setFValue={setSizeWidth}
							sValue={sizeHeight}
							setSValue={setSizeHeight}
						/>
						<SettingMultiInput
							title={'x값'}
							content={'y값'}
							fValue={xAxis}
							setFValue={setXAxis}
							sValue={yAxis}
							setSValue={setYAxis}
						/>

						<PopUpWrapper>
							<Switch
								size="small"
								defaultChecked={activate}
								onChange={checked => {
									setActivate(checked)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<Switch
								size="small"
								defaultChecked={mobileUse}
								onChange={checked => {
									setMobileUse(checked)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<DatePicker
								defaultValue={dayjs(startDate, 'YYYY-MM-DD')}
								onChange={(date, dateString) => {
									setStartDate(dateString)
								}}
							/>
						</PopUpWrapper>
						<PopUpWrapper>
							<DatePicker
								defaultValue={dayjs(endDate, 'YYYY-MM-DD')}
								onChange={(date, dateString) => {
									setEndDate(dateString)
								}}
							/>
						</PopUpWrapper>
					</PopUpInputSection>
				</View>

				<View
					style={{
						marginTop: 10,
						width: '100%',
						flexDirection: 'row',
						justifyContent: 'space-between',
					}}>
					<Button
						onClick={() => {
							const t = encodeURIComponent(title)
							
							let cleanContent = content;
							if (content === '<p class="editor-paragraph"><br></p>' || content === '<p><br></p>') {
								cleanContent = '';
							}
							
							const c = encodeURIComponent(cleanContent)
							const i = encodeURIComponent(JSON.stringify(images))

							window.open(
								`/popup.html?title=${t}&content=${c}&images=${i}&height=${sizeHeight}&width=${sizeWidth}`,
								'_blank',
								`width=${sizeWidth},height=${sizeHeight},left=${xAxis},top=${yAxis}`
							)
						}}>
						미리보기
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						style={{ width: '70%' }}>
						저장
					</Button>
				</View>
			</Form>
		</AdminCModal>
	)
}

export default PopUpUpdateModal
